import {
    server
} from "@/api";

const prefix = 'api/connections';

/**
 * List connections with optional filters and pagination
 * @param {Object} params - Query parameters
 * @param {string} [params.status] - Filter by connection status
 * @param {string} [params.search] - Search term for filtering
 * @param {number} [params.page] - Page number for pagination
 * @param {number} [params.per_page] - Items per page
 * @returns {Promise} Paginated list of connections
 */
export const paginate = async (params) => {
    return await server().get(prefix, { params });
}

/**
 * Send a connection request to a user
 * @param {number|string} receiverId - ID of the user to connect with
 * @param {string} [message] - Optional message (max 500 chars)
 * @returns {Promise} Created connection request
 */
export const sendRequest = async (receiverId, message = '') => {
    return await server().post(`${prefix}/request`, {
        receiver_id: receiverId,
        message: message
    });
}

/**
 * Respond to a connection request
 * @param {number|string} connectionId - ID of the connection request
 * @param {string} action - Action type ('accept' or 'decline')
 * @returns {Promise} Updated connection
 */
export const respondToRequest = async (connectionId, action) => {
    return await server().post(`${prefix}/${connectionId}/response`, {
        action: action
    });
}

/**
 * Cancel a pending connection request
 * @param {number|string} connectionId - ID of the connection request
 * @returns {Promise} Cancelled connection
 */
export const cancelRequest = async (connectionId) => {
    return await server().post(`${prefix}/${connectionId}/cancel`);
}

/**
 * Delete an established connection
 * @param {number|string} connectionId - ID of the connection
 * @returns {Promise} Deleted connection
 */
export const deleteConnection = async (connectionId) => {
    return await server().delete(`${prefix}/${connectionId}`);
}

const connectionsApi = {
    paginate,
    sendRequest,
    respondToRequest,
    cancelRequest,
    deleteConnection
};

export default connectionsApi;